export const COMPANY = {
  name: "San José Shipping LLC",
  phone1: "(718) 600-1183",
  phone2: "(718) 576-5760",
  whatsapp: "13473668908", // E.164 without +
  whatsappDisplay: "(347) 366-8908",
  address: "415 E 176 St, Bronx, NY 10457",
  hours: "Lunes a Sábado · 8:00 AM - 6:00 PM",
  instagram: "https://instagram.com/san_jose_shipping",
  facebook: "https://www.facebook.com/share/198ovSW7fh/?mibextid=wwXIfr",
  email: "info@sanjoseshippingllc.com",
  logo: "/logo.jpg",
};

export const buildWhatsAppLink = (message) => {
  const text = encodeURIComponent(message || "Hola, quisiera cotizar un envío a República Dominicana.");
  return `https://wa.me/${COMPANY.whatsapp}?text=${text}`;
};
